export default __webpack_public_path__ + "static/media/lain-logo-ab.f8d4d32e.png";